import React from "react";
import { Prompt } from "react-router-dom";
import {
  FormLabel,
  Row,
  Col,
  FormGroup,
  Tabs,
  Tab,
  Button
} from "react-bootstrap";
import { labels } from "../../../../localization/labels";
import SubmitControl from "../../../core/SubmitControl";
import DropDown from "../../../core/DropDown";
import ClassificationSelection from "../../page/ClassificationSelection";
import Document from "./Document";
import { Affix, Rate } from "antd";
import MessageLog from "./MessageLog";
import { messages } from "../../../../localization/messages";
import LifeCycleHistoryLog from "./LifeCycleHistroyLog";
import AdditionalData from "./AdditionalData";
import KnowledgeSource from "./KnowledgeSource";
import UserInformations from "./UserInformations";
import ComponentHeader from "../../../core/ComponentHeader/ComponentHeader";
import SubmitButton from "../../../core/SubmitButton";

const rate = props => {
  return (
    <Row>
      <Col sm="2">
        <FormLabel className="Label">{labels.myRating}</FormLabel>
      </Col>
      <Col className="rate-now">
        <div>
          <Rate
            value={Number(props.rating)}
            onChange={props.onRatingChange}
            allowClear={false}
          ></Rate>
          <Button
            variant="link"
            onClick={props.onRate}
            disabled={!(props.rating && props.rating > 0)}
          >
            {labels.rateNow}{" "}
          </Button>
        </div>
      </Col>
    </Row>
  );
};

const rating = props => {
  return (
    <Row>
      <Col sm="2">
        <FormLabel className="Label">{labels.rating}</FormLabel>
      </Col>
      <Col className="rating">
        {" "}
        <Rate
          disabled
          allowHalf
          value={props.knowledgeRatings.averageRating}
        />{" "}
        (
        {props.knowledgeRatings.votesCount
          ? props.knowledgeRatings.votesCount
          : 0}{" "}
        <span> {labels.ratings})</span>
      </Col>
    </Row>
  );
};

const getBody = props => {
  const knowledgeitem = props.knowledgeItem;

  return (
    <>
      <div className="container">
        <div className="tabVerticalSize" />
        <div className="distance-from-tab" />
        <ComponentHeader
          title={labels.knowledgeItem}
          id={knowledgeitem.id}
          showBackButton
        />
        <div className="bordered_bottom_rounded">
          <br></br>
          {!props.isNew ? rating(props) : null}
          <Row>
            <Col sm="2">
              <FormLabel className="Label">{labels.name}</FormLabel>
            </Col>
            <Col sm="10">
              <FormGroup controlId="name">
                <SubmitControl
                  autoFocus
                  type="text"
                  title={labels.name}
                  value={knowledgeitem.name}
                  onChange={props.onChange}
                  placeholder={labels.name}
                  validationRule={props.validationRules.name}
                  readOnly={!props.editable}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm="2">
              <FormLabel className="Label">{labels.dateFromTo}</FormLabel>
            </Col>
            <Col sm="5">
              <FormGroup controlId="dateFromTo">
                <SubmitControl
                  type="dateRange"
                  placeholder={[
                    labels.dateFromPlaceholder,
                    labels.dateToPlaceholder
                  ]}
                  validationRule={
                    props.validationRules && props.validationRules.dateFromTo
                  }
                  value={knowledgeitem.dateFromTo}
                  onChange={props.onChange}
                  controlId={"dateFromTo"}
                  readOnly={!props.editable}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm="2">
              <FormLabel className="Label">{labels.description}</FormLabel>
            </Col>
            <Col sm="10">
              <FormGroup controlId="description">
                <SubmitControl
                  placeholder={labels.description}
                  as="textarea"
                  value={knowledgeitem.description}
                  onChange={props.onChange}
                  rows="2"
                  readOnly={!props.editable}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm="2">
              <FormLabel className="Label">{labels.descriptionUsage}</FormLabel>
            </Col>
            <Col sm="10">
              <FormGroup controlId="descriptionUsage">
                <SubmitControl
                  as="textarea"
                  title={labels.descriptionUsage}
                  value={knowledgeitem.descriptionUsage}
                  onChange={props.onChange}
                  placeholder={labels.descriptionUsage}
                  readOnly={!props.editable}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm="2">
              <FormLabel className="Label">{labels.knowledgeType}</FormLabel>
            </Col>
            <Col sm="10">
              <FormGroup controlId="knowledgeType">
                <DropDown
                  value={knowledgeitem.knowledgeType}
                  options={props.knowledgeTypes.map(x => ({
                    value: x,
                    label: x.name
                  }))}
                  onChange={props.onChange}
                  targetId={"knowledgeType"}
                  placeholder={labels.knowledgeType}
                  required={
                    props.validationRules.knowledgeType &&
                    props.validationRules.knowledgeType.required
                  }
                  readOnly={!props.editable}
                />
              </FormGroup>
            </Col>
          </Row>
          {!props.isNew ? (
            <Row>
              <Col sm="2">
                <FormLabel className="Label">{labels.lifeCycle}</FormLabel>
              </Col>
              <Col sm="10">
                <FormGroup controlId="lifeCycle">
                  <DropDown
                    value={knowledgeitem.lifeCycle}
                    options={props.knowledgeLifeCycles.map(x => ({
                      value: x,
                      label: x.name
                    }))}
                    onChange={props.onChange}
                    targetId={"lifeCycle"}
                    placeholder={labels.lifeCycles}
                    readOnly={!props.lifeCycleEditable}
                  />
                </FormGroup>
              </Col>
            </Row>
          ) : null}
          {!props.isNew ? rate(props) : null}
          <Tabs>
            <Tab
              eventKey="additionalData"
              title={labels.additionalData}
              className="Tab"
              mountOnEnter
            >
              <AdditionalData
                validationRules={props.validationRules}
                onChange={props.onChange}
                knowledgeItem={knowledgeitem}
                messageHandler={props.messageHandler}
                setInitialEntityPropertyState={
                  props.setInitialEntityPropertyState
                }
                editable={props.editable}
              />
            </Tab>

            <Tab
              eventKey="classification"
              title={labels.classification}
              className="Tab"
              mountOnEnter
            >
              <Row>
                <Col>
                  <ClassificationSelection
                    entity={knowledgeitem}
                    messageHandler={props.messageHandler}
                    breadcrumbsHandler={props.breadcrumbsHandler}
                    setInitialEntityPropertyState={
                      props.setInitialEntityPropertyState
                    }
                    setClassificationsOnEntity={
                      props.setClassificationsOnEntity
                    }
                    readOnly={!props.editable}
                    classificationsFilter={props.classificationsFilter}
                  />
                </Col>
              </Row>
            </Tab>
            <Tab
              eventKey="knowledgeSource"
              title={labels.knowledgeSource}
              className="Tab"
              mountOnEnter
            >
              <KnowledgeSource
                knowledgeItem={knowledgeitem}
                onChange={props.onChange}
                messageHandler={props.messageHandler}
                setInitialEntityPropertyState={
                  props.setInitialEntityPropertyState
                }
                editable={props.editable}
                resetKnowledgeSourceOnOldItem={
                  props.resetKnowledgeSourceOnOldItem
                }
              />
            </Tab>
            {!props.isNew ? (
              <Tab
                eventKey="documents"
                title={labels.documents}
                className="Tab"
                mountOnEnter
              >
                <Document
                  entity={knowledgeitem}
                  messageHandler={props.messageHandler}
                  breadcrumbsHandler={props.breadcrumbsHandler}
                  editable={props.editable}
                ></Document>
              </Tab>
            ) : null}
            {!props.isNew ? (
              <Tab
                eventKey="userInfo"
                title={labels.userInformation}
                className="Tab"
                mountOnEnter
              >
                <UserInformations
                  knowledgeItem={knowledgeitem}
                  loadParty={props.loadParty}
                />
              </Tab>
            ) : null}
            {!props.isNew ? (
              <Tab
                eventKey="messageLogs"
                title={labels.messageLog}
                className="Tab"
                mountOnEnter
              >
                <MessageLog
                  messageHandler={props.messageHandler}
                  breadcrumbsHandler={props.breadcrumbsHandler}
                  entity={knowledgeitem}
                />
              </Tab>
            ) : null}
            {!props.isNew && knowledgeitem ? (
              <Tab
                eventKey="lifeCycles"
                title={labels.lifeCycles}
                className="Tab"
                mountOnEnter
              >
                <LifeCycleHistoryLog
                  entity={knowledgeitem}
                  messageHandler={props.messageHandler}
                />
              </Tab>
            ) : null}
          </Tabs>
        </div>
        <Affix offsetBottom={true}>
          <div className="bottom_bar">
            <SubmitButton
              type="save"
              onClick={props.onSave}
              disabled={props.disabled}
              readOnly={!props.editable && !props.lifeCycleEditable}
            />
          </div>
        </Affix>
      </div>
    </>
  );
};

const Knowledgeitem = props => (
  <React.Fragment>
    <Prompt
      when={props.shouldBlockNavigation}
      message={messages.changesNotSavedMessage}
    />
    {getBody(props)}
  </React.Fragment>
);

export default Knowledgeitem;
